export default "<!-- Map -->\r\n<div #gmap class=\"map\">\r\n    <ng-content></ng-content>\r\n</div>"